import { Controller } from '@hotwired/stimulus'

export default class DisplayOnSelectController extends Controller {
  static targets = ['answer', 'warning', 'warningText']
  static values = { incorrectAnswers: Object }

  connect() {
    this.displayWarning();
  }
  
  displayWarning() {
    let hasIncorrectAnswer = false;
    let warningMessages = [];

    this.answerTargets.forEach((element) => {
      if (!element.checked) return;

      if (element.value in this.incorrectAnswersValue) {
        hasIncorrectAnswer = true;
        warningMessages.push(this.incorrectAnswersValue[element.value]);
      }
    });

    if (hasIncorrectAnswer) {
      this.warningTarget.classList.remove('d-none');
      this.warningTextTarget.innerHTML = warningMessages.join('<br>');
    } else {
      this.warningTarget.classList.add('d-none');
      this.warningTextTarget.innerHTML = '';
    }
  }
} 
